import React from 'react'

import {
  string,
  array,
  bool,
  func,
} from 'prop-types'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import MenuItemIcon from './Components/MenuItemIcon/MenuItemIcon'

function MenuItem({
  title,
  url,
  icon = null,
  svgComponent = null,
  className = '',
  dataName,
  isFontAwesomeIcon = false,
  children,
  dataMethod = 'get',
  onClick = null,
}) {
  const isWithIcon = !!icon || !!svgComponent

  return (
    <a
      href={url}
      className={classnames(
        'cgt-menu-item',
        'cgt-menu-item--medium',
        'undecorated-text',
        'user-menu-item',
        'js-track-link-click',
        className,
        isWithIcon && 'cgt-menu-item--icon-left'
      )}
      data-keyword={dataName}
      data-track-text={title}
      data-track-label="Profile"
      data-method={dataMethod}
      onClick={onClick}
    >
      {isWithIcon && (
        <span className="cgt-menu-item__lead-icon">
          <div className={classnames(
            'cgt-icon',
            'cgt-icon__icon',
            'cgt-icon--small',
            'cgt-icon--not-spaced',
            svgComponent ? 'cgt-icon--dark' : 'cgt-icon--light'
          )}>
            <MenuItemIcon icon={icon} svgComponent={svgComponent} isFontAwesomeIcon={isFontAwesomeIcon} />
          </div>
        </span>
      )}
      <span className="cgt-menu-item__text">
        {title}
      </span>

      {!!children && (
        <span className="cgt-menu-item__trail-icon">
          {children}
        </span>
      )}
    </a>
  )
}

MenuItem.propTypes = {
  title: string.isRequired,
  url: string.isRequired,
  icon: array,
  svgComponent: func,
  className: string,
  dataName: string.isRequired,
  isFontAwesomeIcon: bool,
  dataMethod: string,
  onClick: func,
}

export default MenuItem
